import { Grid, GridItem, GridProps } from "@chakra-ui/react";
import React, { ReactElement, useMemo } from "react";
import { useWindowSize } from "usehooks-ts";

function DynamicGrid({
  children,
  baseChildKey,
  cloneChildToFitSize,
  grid,
  dynamicGridProps,
}: {
  baseChildKey: string;
  children?: ReactElement[] | ReactElement;
  cloneChildToFitSize?: boolean;
  grid?: {
    md?: number;
    base?: number;
    lg?: number;
  };
  dynamicGridProps?: GridProps;
}) {
  const { width } = useWindowSize();

  const childrenArray = useMemo(() => {
    const childArr = React.Children.toArray(children);

    if (cloneChildToFitSize && childArr.length === 1) {
      const numberOfChildren = Math.ceil(width / 400);
      const numberOfChildrenToClone = numberOfChildren - childArr.length;
      for (let i = 0; i < numberOfChildrenToClone; i++) {
        React.isValidElement(childArr[0]) &&
          childArr.push(
            React.cloneElement(childArr[0], {
              key: baseChildKey + i,
            }),
          );
      }
    }
    return childArr;
  }, [children, cloneChildToFitSize, width, baseChildKey]);

  return (
    <Grid
      mt={{ base: "1rem", xl: "2rem" }}
      templateColumns={{
        base: `repeat(${Math.ceil(width / (grid?.base || 390))},1fr)`,
        md: `repeat(${Math.ceil(width / (grid?.md || 400))},1fr)`,
        lg: `repeat(${Math.ceil(width / (grid?.lg || 400))},1fr)`,
      }}
      gap={{
        base: 2,
        xl: 10,
      }}
      {...dynamicGridProps}
    >
      {childrenArray.map((child, index: number) => (
        <GridItem key={baseChildKey + index}>
          <>{child}</>
        </GridItem>
      ))}
    </Grid>
  );
}

export default DynamicGrid;
